import { getGlobalConfig } from 'shared/helpers/runtimeConfig';

const {
  API_CHANNEL_NAME: apiChannelName,
  API_CHANNEL_THUMBNAIL: apiChannelThumbnail,
  APP_VERSION: appVersion,
  AZURE_APP_ID: azureAppId,
  BRAND_NAME: brandName,
  OTELLO_INBOX_TOKEN: otelloInboxToken,
  DIRECT_UPLOADS_ENABLED: directUploadsEnabled,
  DISPLAY_MANIFEST: displayManifest,
  GIT_SHA: gitSha,
  HCAPTCHA_SITE_KEY: hCaptchaSiteKey,
  INSTALLATION_NAME: installationName,
  LOGO_THUMBNAIL: logoThumbnail,
  LOGO: logo,
  LOGO_DARK: logoDark,
  PRIVACY_URL: privacyURL,
  TERMS_URL: termsURL,
  TURNSTILE_SITE_KEY: turnstileSiteKey,
  WIDGET_BRAND_URL: widgetBrandURL,
  DISABLE_USER_PROFILE_UPDATE: disableUserProfileUpdate,
  DEPLOYMENT_ENV: deploymentEnv,
  SYSTEM_BANNER: systemBanner,
} = getGlobalConfig();

const state = {
  apiChannelName,
  apiChannelThumbnail,
  appVersion,
  azureAppId,
  brandName,
  otelloInboxToken,
  deploymentEnv,
  directUploadsEnabled: directUploadsEnabled === 'true',
  disableUserProfileUpdate: disableUserProfileUpdate === 'true',
  displayManifest,
  gitSha,
  hCaptchaSiteKey,
  installationName,
  logo,
  logoDark,
  logoThumbnail,
  privacyURL,
  termsURL,
  turnstileSiteKey,
  widgetBrandURL,
  systemBanner,
};

export const getters = {
  get: ($state) => $state,
  isOnOtelloCloud: ($state) => $state.deploymentEnv === 'cloud',
  isACustomBrandedInstance: ($state) => $state.installationName !== 'Otello',
  isAnOtelloInstance: ($state) => $state.installationName === 'Otello',
};

export const actions = {};

export const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
